import { useContext } from "react";
import { Container } from "lucide-react";
export default function ShipmentTag({ shipment, maxWidth }) {
  return (
    <div
      style={{ maxWidth: maxWidth || 280 }}
      className="rounded-md bg-white shadow-sm inline-flex items-center divide-x border text-xs font-medium"
    >
      <div className="py-1 pl-2 inline-flex hover:bg-gray-50 cursor-pointer items-center space-x-2">
        <Container size={12} />
        <p className="inline pr-3" style={{ width: "auto" }}>
          {shipment.container ||
            shipment.hbl_hawb ||
            shipment.mbl_mawb ||
            shipment.rectangle_id ||
            "N/A"}
        </p>
      </div>

      <div
        className="py-1 px-2 truncate hidden lg:flex items-center"
        style={{ maxWidth: 120 }}
      >
        <p className="truncate">
          {shipment.shipper || shipment.consignee_or_cargo_owner}
        </p>
      </div>
    </div>
  );
}
